import React from "react";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import Header from "../components/header/Header";
import {Footer} from "../components/footer/Footer";

const Home = () => {
    const {t} = useTranslation();

    const incentives = [
        {
            name: 'Free shipping',
            imageSrc: 'https://tailwindcss.com/plus-assets/img/ecommerce/icons/icon-shipping-simple.svg',
            description: "It's not actually free we just price it into the products. Someone's paying for it, and it's not us.",
        },
        {
            name: '10-year warranty',
            imageSrc: 'https://tailwindcss.com/plus-assets/img/ecommerce/icons/icon-warranty-simple.svg',
            description: "If it breaks in the first 10 years we'll replace it. After that you're on your own though.",
        },
        {
            name: 'Exchanges',
            imageSrc: 'https://tailwindcss.com/plus-assets/img/ecommerce/icons/icon-exchange-simple.svg',
            description:
                "If you don't like it, trade it to one of your friends for something of theirs. Don't send it here though.",
        },
    ]

    return (
        <div className="bg-white">
            <Header/>
            <div className="relative overflow-hidden mt-12 mb-12">
                <div className="pb-80 pt-16 sm:pb-40 sm:pt-24 lg:pb-48 lg:pt-40">
                    <div className="relative mx-auto max-w-7xl px-4 sm:static sm:px-6 lg:px-8">
                        <div className="sm:max-w-lg">
                            <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
                                {t('HOME.TITLE')}
                            </h1>
                            <p className="mt-4 text-xl text-gray-500">
                                {t('HOME.SUBTITLE')}
                            </p>
                        </div>
                        <div>
                            <div className="mt-10">
                                {/* Decorative image grid */}
                                <div
                                    aria-hidden="true"
                                    className="pointer-events-none lg:absolute lg:inset-y-0 lg:mx-auto lg:w-full lg:max-w-7xl"
                                >
                                    <div
                                        className="absolute transform sm:left-1/2 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8">
                                        <div className="flex items-center space-x-6 lg:space-x-8">
                                            <div className="grid shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                                                <div
                                                    className="h-64 w-44 overflow-hidden rounded-lg sm:opacity-0 lg:opacity-100">
                                                    <img
                                                        alt=""
                                                        src={require('../images/1.jpg')}
                                                        className="size-full object-cover"
                                                    />
                                                </div>
                                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                                    <img
                                                        alt=""
                                                        src={require('../images/2.jpg')}
                                                        className="size-full object-cover"
                                                    />
                                                </div>
                                            </div>
                                            <div className="grid shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                                    <img
                                                        alt=""
                                                        src="https://metcon-uploads.s3.eu-central-1.amazonaws.com/shop/1/1.png"
                                                        className="size-full object-cover"
                                                    />
                                                </div>
                                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                                    <img
                                                        alt=""
                                                        src="https://metcon-uploads.s3.eu-central-1.amazonaws.com/shop/1/2.png"
                                                        className="size-full object-cover"
                                                    />
                                                </div>
                                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                                    <img
                                                        alt=""
                                                        src="https://metcon-uploads.s3.eu-central-1.amazonaws.com/shop/1/3.png"
                                                        className="size-full object-cover"
                                                    />
                                                </div>
                                            </div>
                                            <div className="grid shrink-0 grid-cols-1 gap-y-6 lg:gap-y-8">
                                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                                    <img
                                                        alt=""
                                                        src="https://metcon-uploads.s3.eu-central-1.amazonaws.com/shop/1/2.png"
                                                        className="size-full object-cover"
                                                    />
                                                </div>
                                                <div className="h-64 w-44 overflow-hidden rounded-lg">
                                                    <img
                                                        alt=""
                                                        src={require('../images/3.jpg')}
                                                        className="size-full object-cover"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <Link to={'/configurator'} className="inline-block rounded-md border border-transparent bg-yellow-400 px-8 py-3 text-center font-medium transition duration-300 text-gray-700 hover:bg-yellow-500">
                                    {t('HOME.BUTTON')}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/*New section*/}

            <div className="bg-gray-100">
                <div className="mx-auto max-w-7xl py-24 sm:px-2 sm:py-32 lg:px-4">
                    <div className="mx-auto max-w-2xl px-4 lg:max-w-none">
                        <div className="grid grid-cols-1 items-center gap-x-16 gap-y-10 lg:grid-cols-2">
                            <div>
                                <h2 className="text-4xl font-bold tracking-tight text-gray-900">
                                    We built our business on great customer service
                                </h2>
                                <p className="mt-4 text-gray-500">
                                    At the beginning at least, but then we realized we could make a lot more money if we
                                    kinda stopped
                                    caring about that. Our new strategy is to write a bunch of things that look really
                                    good in the
                                    headlines, then clarify in the small print but hope people don't actually read it.
                                </p>
                            </div>
                            <img
                                alt=""
                                src={require('../images/start.png')}
                                className="aspect-[3/2] w-full rounded-lg bg-gray-100 object-cover"
                            />
                        </div>
                        <div className="mt-16 grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-3">
                            {incentives.map((incentive) => (
                                <div key={incentive.name} className="sm:flex lg:block">
                                    <div className="sm:shrink-0">
                                        <img alt="" src={incentive.imageSrc} className="size-16"/>
                                    </div>
                                    <div className="mt-4 sm:ml-6 sm:mt-0 lg:ml-0 lg:mt-6">
                                        <h3 className="text-sm font-medium text-gray-900">{incentive.name}</h3>
                                        <p className="mt-2 text-sm text-gray-500">{incentive.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Home;